const presets = [
  {
    id: "general", label: "一般講義與考卷", category: "通用版", tone: "blue",
    description: "適合一般講義、混合教材與考卷，先自動分類，再對照原稿核對。",
    tags: ["講義", "考卷", "混合教材"],
    detail: "沒有固定版型時，從這裡開始。保留觀念、題目、答案與附圖的原有順序。",
    workflow: ["保留完整內容", "核對分類與答案", "批次處理附圖"],
  },
  {
    id: "liu_liwei", label: "劉力維講義", category: "專屬版", tone: "teal",
    description: "整理觀念表格、例題與回家練習，保留題目和獨立詳解。",
    tags: ["觀念表格", "例題與練習", "獨立詳解"],
    detail: "依劉力維講義的觀念表格、例題與回家練習結構整理。重複題號各自保留，再對照原稿核對獨立詳解。",
    workflow: ["整理觀念與練習", "核對題目與詳解", "批次處理附圖"],
  },
  {
    id: "gm", label: "GM 講義", category: "專屬版", tone: "violet",
    description: "整理 GM 講義與筆記，依原稿閱讀順序保留觀念、題目和附圖。",
    tags: ["單頁與跨頁", "課堂筆記", "附圖核對"],
    detail: "辨識單頁與左右跨頁版面，依閱讀順序整理內容。手寫註記與附圖一併保留，方便逐區核對。",
    workflow: ["辨識跨頁與順序", "核對筆記與題目", "批次處理附圖"],
  },
];

export const materialTemplateAvailable = (entry) => Boolean(entry)
  && entry.available !== false && entry.enabled !== false && entry.status !== "planned";

// Presentation can be previewed before a parser is released; submission always
// requires an available entry returned by the backend catalog.
export const materialTemplateChoices = (catalog = []) => {
  const entries = new Map(catalog.map((entry) => [entry.id || entry.template_id, entry]));
  const known = presets.map((preset) => {
    const entry = entries.get(preset.id);
    return { ...entry, ...preset, available: materialTemplateAvailable(entry) };
  });
  const extra = catalog.filter((entry) => !presets.some((preset) => preset.id === (entry.id || entry.template_id)))
    .map((entry) => ({ ...entry, id: entry.id || entry.template_id, label: entry.label || entry.name || entry.title,
      category: "專屬版", tone: "blue", tags: [], workflow: ["解析教材", "核對內容", "處理附圖"],
      detail: entry.description, available: materialTemplateAvailable(entry) }));
  return [...known, ...extra];
};
